import { render, staticRenderFns } from "./ClientHeader.vue?vue&type=template&id=0d7aede1&scoped=true&"
import script from "./ClientHeader.vue?vue&type=script&lang=js&"
export * from "./ClientHeader.vue?vue&type=script&lang=js&"
import style0 from "./ClientHeader.vue?vue&type=style&index=0&id=0d7aede1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7aede1",
  null
  
)

export default component.exports